import { useEffect } from 'react'
import { trackExperimentViewed } from '@mc/track-event'
import { PEN_6957_V2_CM_SKINNY_CM_FLAG } from '../constants'
import { isEligibleSlug } from '../skills'

/**
 * Fires "Experiment Viewed" on page load for EVERY bucket, but only on classes
 * eligible for the experiment (those with ingested skills data). Ineligible
 * classes can never open the modal — not in any variant — so tracking
 * exposure there would dilute the population with users who cannot receive the
 * treatment, flattening the measured effect. Eligibility is bucket-independent,
 * so control is still tracked on eligible classes.
 *
 * Takes the class slug from the caller: this hook runs at the CM page level,
 * above the page's StaticDataProvider, so `useStaticData` cannot see `course`
 * here — the slug is passed from the page props instead.
 */
export const useTrackPen6957Experiment = (slug: string | undefined) => {
  const eligible = isEligibleSlug(slug)

  useEffect(() => {
    if (eligible) {
      trackExperimentViewed(PEN_6957_V2_CM_SKINNY_CM_FLAG)
    }
  }, [eligible])
}
